import { useState, useRef, useLayoutEffect } from "react"

import styled from "@emotion/styled"
import { FocusScope } from "@react-aria/focus"
import { usePreventScroll } from "react-aria"
import useScrollLock from "hooks/useScrollLock"

const Modal = styled.div`
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100dvh;
  overflow: auto;
  overscroll-behavior: none;

  &.headerized {
    z-index: 9997;
  }

  &.wv_hide {
    > button {
      visiblity: hidden;
    }
  }

  &:focus-within {
    nav {
      visibility: visible;
    }
  }
`

export function CfgModal({ children, className }) {
  const rfmodal = useRef(null)
  const scrollLock = useScrollLock()
  const [lockit, setLockit] = useState(false)
  usePreventScroll({ isDisabled: lockit })


  useLayoutEffect(() => {
    const el = rfmodal.current
    scrollLock.lock(el)

    return () => {
      setLockit(true)
      scrollLock.unlock(el)
    }
  }, [])

  return (
    <FocusScope contain restoreFocus>
      <Modal
        role='dialog'
        aria-modal='true'
        aria-labelledby='config-modal-heading'
        ref={rfmodal}
        className={["cfgv7Modal", className].filter(Boolean).join(" ")}
      >
        {children}
      </Modal>
    </FocusScope>
  )
}
